import defaultOptions from '@atlassian/jira-common-constants/src/fetch-default-options';
import { GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY } from '@atlassian/jira-common-constants/src/project-template-type-keys';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';

import { performPostRequest } from '@atlassian/jira-fetch';

export interface CreateJSMProjectResponseType {
	self: string;
	id: number;
	key: string;
}

const getValidProjectName = async (name: string): Promise<string> => {
	try {
		const validName = await fetch(
			`/rest/api/3/projectvalidate/validProjectName?name=${name}`,
			defaultOptions,
		);
		if (validName === null) {
			throw new Error('Unable to generate valid project name');
		}
		if (!validName.ok) {
			throw new Error('Failed request at Validating Project Name');
		}
		return validName.text();
	} catch (error: unknown) {
		if (error instanceof Error) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'validateProjectName',
					packageName: 'jiraProjectsDirectoryV3',
					teamName: 'jira-cosmos',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}

		throw error;
	}
};

const getValidProjectKey = async (key: string): Promise<string> => {
	try {
		const response = await fetch(
			`/rest/api/3/projectvalidate/validProjectKey?key=${key}`,
			defaultOptions,
		);
		if (!response.ok) {
			throw new Error('Failed request at Validating Project Key');
		}
		return response.text();
	} catch (error: unknown) {
		if (error instanceof Error) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'validateProjectKey',
					packageName: 'jiraProjectsDirectoryV3',
					teamName: 'jira-cosmos',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		throw error;
	}
};

export const createFirstJSMProject = async (
	leadAccountId: string,
): Promise<CreateJSMProjectResponseType> => {
	try {
		let projectName = 'Service Desk';
		let projectKey = 'SD';
		projectName = await getValidProjectName(projectName);
		[projectName, projectKey] = await Promise.all([
			getValidProjectName(projectName),
			getValidProjectKey(projectKey),
		]);
		return await performPostRequest('/rest/api/3/project', {
			body: JSON.stringify({
				name: projectName,
				key: projectKey,
				leadAccountId,
				projectTemplateKey: GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY,
				projectTypeKey: 'service_desk',
			}),
		});
	} catch (error: unknown) {
		if (error instanceof Error) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'createFirstJSMProject',
					packageName: 'jiraProjectsDirectoryV3',
					teamName: 'jira-cosmos',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		throw error;
	}
};
